import React, { useEffect } from 'react';

import Button from '@amzn/meridian/button';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import {
  downloadSiteCapacitySummaryCsv,
  getShifts,
  getSiteCapacity,
  setCurrentPage,
  setPerPage,
  setSearchField,
} from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';

import './updateSiteCapacity.scss';

import SiteCapacityModal from './siteCapacityModal/siteCapacityModal';
import SiteCapacityTable from './siteCapacityTable/siteCapacityTable';
import TopOptions from './topOptions/topOptions';

const UpdateSiteCapacity = () => {
  const dispatch = useAppDispatch();
  const { isLoading, currentPage, perPage, totalPages } = useAppSelector((state) => state.updateSiteCapacityPage);
  const { preferredSite } = useAppSelector((state) => state.user);
  const { userLoading } = useAppSelector((state) => state.user);

  useEffect(() => {
    // TODO when user first time log into website and they have no preferredSite
    // we should either give them a preferredSite or show message let them pick a site
    if (userLoading === 'fulfilled' && preferredSite !== 0) {
      dispatch(setCurrentPage(1));
      dispatch(getSiteCapacity());
      dispatch(getShifts());
    }
    return () => {
      dispatch(setSearchField(''));
    };
  }, [userLoading, preferredSite, dispatch]);

  return (
    <div className="update-site-capacity">
      {!isLoading ? (
        <>
          <Row width="100%" widths={['fill', 'fit']}>
            <Heading level={1} type="h500" className="update-site-capacity__page-heading">
              Update Site Capacity
            </Heading>
            <Button
              id="update-placement-status-save-btn"
              type="primary"
              size="medium"
              onClick={() => dispatch(downloadSiteCapacitySummaryCsv())}
            >
              Export Capacity Summary
            </Button>
          </Row>
          <Text>
            Here you can view and edit jobs available at your site, as well as capacity available for accommodations per
            shift
          </Text>
          <TopOptions />
          <SiteCapacityTable />
          <PaginationWithDropdown
            currentPage={currentPage}
            totalPages={totalPages}
            perPage={perPage}
            setPerPage={(newPerPage) => dispatch(setPerPage(newPerPage))}
            setCurrentPage={(newPage) => dispatch(setCurrentPage(newPage))}
          />
          <SiteCapacityModal />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default UpdateSiteCapacity;
